<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="d-flex justify-content-between align-items-center mb-3">
  <h5 class="font-medium" id="positions">
    {{ 'mydepot.depotoverview.positions.headline' | transloco }}
  </h5>

  @if (actionsEnabled) {
    <div class="d-flex align-items-center">
      @if (currentlyEditingEntryQuote) {
        <div class="ml-2 mr-2 text-size-medium border-default p-1 pl-2 pr-2">
          {{ 'mydepot.depotoverview.positions.editable-entry-quotes.label' | transloco }}
        </div>
      }
      @if (currentCustomer) {
        <div class="circle mr-2 cursor-pointer">
          <a
            [href]="environment.apihost + '/api/trading/positions.csv?customerId=' + currentCustomer.custId"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg class="icon icon-16 text-color-grey">
              <use xlink:href="/assets/img/svgs/svgset.svg#download-redesign-23" />
            </svg>
          </a>
        </div>
      }
      <web-design-system-list-toggle (click)="showPositions = !showPositions" [isCollapsed]="!showPositions" />
    </div>
  }
</div>
@if (showPositions) {
  <div class="d-flex mb-3 badge-container align-content-center">
    <web-components-position-filter
      [positions]="positions"
      [hasSavingsPlans]="(savingPlanFacade.savingsPlans$ | async)?.length > 0"
      [overrideCurrentFilter]="overrideCurrentFilter"
      (filterChanged)="filterPositions($event)"
    />
    <tags-dropdown type="position" class="mr-2" />
    @if (positionsSettings$ | async; as settings) {
      @if (positionsFacade.positionsHaveNotes$ | async) {
        <button class="btn btn-toggle mr-2" [class.active]="settings.notesVisible" (click)="toggleNotes(settings)">
          {{ 'mydepot.depotoverview.positions.settings.notes' | transloco }}
        </button>
      }
      @if (showDividendBtn) {
        <button class="btn btn-toggle mr-2" [class.active]="settings.dividendVisible" (click)="toggleDividend(settings)">
          {{ 'mydepot.depotoverview.positions.settings.dividend' | transloco }}
        </button>
      }
      <button
        class="btn btn-toggle"
        [class.active]="settings.protectionsVisible && !settings.dividendVisible"
        (click)="toggleProtections(settings)"
      >
        {{ 'mydepot.depotoverview.positions.settings.protect-order' | transloco }}
      </button>
    }
  </div>
  @if (positionsSettings$ | async; as settings) {
    @if (!settings.dividendVisible) {
      @if (!groupedPositions) {
        <ng-container *ngTemplateOutlet="table; context: { items: filteredPositions, sumItems: sums }" />
      } @else {
        @if (groupedPositions[InstrumentType.Share]) {
          <ng-container *ngTemplateOutlet="groupedTable; context: { type: InstrumentType.Share }" />
        }
        @if (groupedPositions[InstrumentType.Etf]) {
          <ng-container *ngTemplateOutlet="groupedTable; context: { type: InstrumentType.Etf }" />
        }
        @if (groupedPositions[InstrumentType.Funds]) {
          <ng-container *ngTemplateOutlet="groupedTable; context: { type: InstrumentType.Funds }" />
        }
        @if (groupedPositions[InstrumentType.Derivative]) {
          <ng-container *ngTemplateOutlet="groupedTable; context: { type: InstrumentType.Derivative }" />
        }
      }
    } @else {
      <ng-container *ngTemplateOutlet="dividendList" />
    }
    <ng-template #dividendList>
      @if (statisticsFacade.dividendYieldsLoading$ | async) {
        <div class="loading-shimmer headline"></div>
        <div class="loading-shimmer position"></div>
        <div class="loading-shimmer position"></div>
        <div class="loading-shimmer position"></div>
        <div class="loading-shimmer position"></div>
      } @else {
        @if (statisticsFacade.dividendYields$ | async; as dividendYields) {
          <ng-container
            *ngTemplateOutlet="
              dividendTable;
              context: {
                items: filteredPositions,
                dividendYields,
                dividendSums: dividendSumsByPeriod,
              }
            "
          />
        }
      }
    </ng-template>
  }
  <web-components-user-messages />
}

<ng-template #groupedTable let-type="type">
  <div class="mb-3">
    <h5 class="font-medium">{{ 'position-filter.' + type | transloco }}</h5>
    <hr class="less-margin" />
    <ng-container *ngTemplateOutlet="table; context: { items: groupedPositions[type], sumItems: getSums(type) }" />
  </div>
</ng-template>

<ng-template #table let-items="items" let-sumItems="sumItems">
  <table
    aria-describedby="positions"
    class="table-depot table-positions opacity-container"
    [class.active]="isPotentialCustomer || items"
    [class.light-opacity]="currentlyEditingEntryQuote || currentlyEditingProtectOrder?.asset?.isin"
    @onlyEnter
  >
    <tbody>
      <tr>
        <th>
          <web-components-sorter-label
            [sorter]="sorter"
            attr="assetName"
            label="mydepot.depotoverview.positions.labels.assetName"
            direction="after"
            (click)="sortBy('assetName')"
          />
          <br />
          <web-components-sorter-label
            [sorter]="sorter"
            attr="isin"
            label="mydepot.depotoverview.positions.labels.isin"
            direction="after"
            (click)="sortBy('isin')"
          />
        </th>
        @if (!currentlyEditingEntryQuote) {
          <th>
            <web-components-sorter-label
              [sorter]="sorter"
              attr="quantity"
              label="mydepot.depotoverview.positions.labels.quantity"
              direction="before"
              (click)="sortBy('quantity')"
            />
            <br />
            @if ((positionsSettings$ | async)?.protectionsVisible) {
              {{ 'mydepot.depotoverview.positions.labels.availableProtections' | transloco }}
            } @else {
              {{ 'mydepot.depotoverview.positions.labels.availableQuantity' | transloco }}
            }
            <ng-template #availableQuantity>
              {{ 'mydepot.depotoverview.positions.labels.availableQuantity' | transloco }}
            </ng-template>
          </th>
        }

        <th [class.ignore-opacity]="currentlyEditingProtectOrder?.asset?.isin">
          {{ 'mydepot.depotoverview.positions.labels.avgEntryQuote' | transloco }}<br />
          <web-components-sorter-label
            [sorter]="sorter"
            attr="entryValue"
            label="mydepot.depotoverview.positions.labels.entryValue"
            direction="before"
            (click)="sortBy('entryValue')"
          />
        </th>
        <th>
          {{ 'mydepot.depotoverview.positions.labels.quote' | transloco }}<br />
          <web-components-sorter-label
            [sorter]="sorter"
            attr="currentValue"
            label="mydepot.depotoverview.positions.labels.currentValue"
            direction="before"
            (click)="sortBy('currentValue')"
          />
        </th>
        <th>
          <web-components-sorter-label
            [sorter]="sorter"
            attr="perfTodayPct"
            label="mydepot.depotoverview.positions.labels.perfTodayPct"
            direction="before"
            (click)="sortBy('perfTodayPct')"
          />
          <br />
          {{ 'mydepot.depotoverview.positions.labels.perfTodayAbs' | transloco }}
        </th>
        <th>
          <web-components-sorter-label
            [sorter]="sorter"
            attr="perfPct"
            label="mydepot.depotoverview.positions.labels.perfPct"
            direction="before"
            (click)="sortBy('perfPct')"
          />
          <br />
          {{ 'mydepot.depotoverview.positions.labels.perfAbs' | transloco }}
        </th>
        <th>
          {{ 'mydepot.depotoverview.positions.labels.quoteTime' | transloco }}<br />
          {{ 'mydepot.depotoverview.positions.labels.quoteDate' | transloco }}
        </th>
        @if (actionsEnabled && !currentlyEditingEntryQuote) {
          <th></th>
        }
      </tr>
      <ng-container *rxFor="let item of items; trackBy: trackById">
        <tr
          zero-position
          [class.no-border]="
            currentlyEditingNote?.isin === item.isin ||
            currentlyEditingTag === item.isin ||
            currentlyEditingProtectOrder?.asset?.isin === item.isin ||
            ((positionsSettings$ | async)?.notesVisible && item.note?.note) ||
            (tagsFacade.displayTags$ | async)
          "
          [item]="item"
          [actionsEnabled]="actionsEnabled"
          [isEditEntryQuoteMode]="!!currentlyEditingEntryQuote"
          [isEditProtectOrderMode]="!!currentlyEditingProtectOrder"
          [isAddTagMode]="!!currentlyEditingTag"
          [isCurrentlyEditing]="currentlyEditingEntryQuote === item.isin"
          [isCurrentlyProtectOrderEditing]="currentlyEditingProtectOrder?.asset?.isin === item.isin"
          [isCurrentlyAddTagMode]="currentlyEditingTag === item.isin"
          [currentEntryQuote]="item.avgEntryQuote | number: '1.2-3'"
          [protectOrderVisible]="(positionsSettings$ | async)?.protectionsVisible"
          (editNote)="editNote(item.isin, item.note?.note)"
          (editEntryQuote)="editEntryQuote(item.isin)"
          (activateProtectOrderMode)="activateProtectOrderMode(item)"
          (updateEntryQuote)="updateEntryQuote($event)"
          (addTagMode)="currentlyEditingTag = item.isin"
          (cancelTagMode)="currentlyEditingTag = undefined"
        ></tr>

        @if (positionsSettings$ | async; as settings) {
          @if (currentlyEditingNote?.isin === item.isin) {
            <tr>
              <td [attr.colspan]="currentlyEditingEntryQuote ? 6 : 8">
                <div class="d-flex">
                  <div class="mr-2">{{ 'watchlist.note' | transloco }}</div>
                  <div class="width-100">
                    <textarea
                      #noteTextArea
                      class="width-100"
                      maxlength="185"
                      [(ngModel)]="currentlyEditingNote.note"
                      (blur)="onSubmitNote(currentlyEditingNote.note, item.isin)"
                    ></textarea>
                    <div>{{ 'mydepot.depotoverview.positions.note-label' | transloco }}</div>
                  </div>
                </div>
              </td>
            </tr>
          } @else {
            @if (settings.notesVisible && item.note?.note) {
              <tr>
                <td [attr.colspan]="currentlyEditingEntryQuote ? 6 : 8">
                  <div class="d-flex align-items-center">
                    <div class="mr-2">{{ 'watchlist.note' | transloco }}</div>
                    <div class="width-100 note" [innerHTML]="item.note.note | noteSafeHtml"></div>
                  </div>
                </td>
              </tr>
            }
          }
          <ng-template #note>
            @if (settings.notesVisible && item.note?.note) {
              <tr>
                <td [attr.colspan]="currentlyEditingEntryQuote ? 6 : 8">
                  <div class="d-flex align-items-center">
                    <div class="mr-2">{{ 'watchlist.note' | transloco }}</div>
                    <div class="width-100 note" [innerHTML]="item.note.note | noteSafeHtml"></div>
                  </div>
                </td>
              </tr>
            }
          </ng-template>
        }

        @if (item.isin === currentlyEditingProtectOrder?.asset?.isin) {
          <tr>
            <td colspan="8" class="ignore-opacity">
              <trade-protect-order
                [asset]="currentlyEditingProtectOrder?.asset"
                [quantity]="currentlyEditingProtectOrder?.quantity"
                [execType]="currentlyEditingProtectOrder?.execType"
                [direction]="currentlyEditingProtectOrder?.direction"
                [quote]="currentlyEditingProtectOrder?.quote"
                [isProtectPositionMode]="true"
                (protectOrder)="protectOrder($event)"
                (cancelProtectPositionMode)="cancelProtectOrderMode()"
                (furtherOrder)="furtherOrder()"
              />
            </td>
          </tr>
        }
        @if (item.isin === currentlyEditingTag || (tagsFacade.displayTags$ | async)) {
          <tr
            tags-link-tag
            [entityId]="item.isin"
            [currentlyEditingTag]="currentlyEditingTag"
            (cancelLinking)="currentlyEditingTag = null"
          ></tr>
        }
      </ng-container>
      @if (!isLoading && (isPotentialCustomer || !filteredPositions?.length)) {
        <tr>
          <td colspan="7">
            {{ 'mydepot.depotoverview.positions.empty' | transloco }}
          </td>
        </tr>
      }
      @if (isLoading) {
        <ng-container *ngTemplateOutlet="loadingShimmer" />
      }
      @for (sum of sumItems; track $index) {
        <tr class="top-align">
          <td>
            <div class="font-bold text-uppercase">
              {{ 'mydepot.depotoverview.positions.sum.label' | transloco }}
              @if (sum.type !== 'ALL') {
                {{ 'position-filter.' + sum.type | transloco }}
              }
            </div>
          </td>
          <td class="hidden-xs hidden-sm"></td>
          <td>
            <div class="d-flex text-color-primary justify-content-end">
              <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                {{ 'mydepot.depotoverview.positions.sum.entryValue' | transloco }}
              </div>
              <div class="text-color-primary">
                {{ sum.entryValue | currency }}
              </div>
            </div>
          </td>
          <td>
            <div class="d-flex text-color-primary justify-content-end">
              <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                {{ 'mydepot.depotoverview.positions.sum.currentValue' | transloco }}
              </div>
              <div class="text-color-primary">
                {{ sum.currentValue | currency }}
              </div>
            </div>
          </td>
          <td>
            <div class="d-flex text-color-primary justify-content-end">
              <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                {{ 'mydepot.depotoverview.positions.sum.perfTodayPct' | transloco }}
              </div>
              <div [class.text-color-success]="sum.perfTodayAbs >= 0" [class.text-color-error]="sum.perfTodayAbs < 0">
                {{ sum.perfTodayPct | number: '1.2-2' }}&nbsp;%
              </div>
            </div>
            <div class="d-flex text-color-primary justify-content-end">
              <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow"></div>
              <div [class.text-color-success]="sum.perfTodayAbs >= 0" [class.text-color-error]="sum.perfTodayAbs < 0">
                {{ sum.perfTodayAbs | currency }}
              </div>
            </div>
          </td>
          <td>
            <div class="d-flex text-color-primary justify-content-end">
              <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                {{ 'mydepot.depotoverview.positions.sum.perfPct' | transloco }}
              </div>
              <div [class.text-color-success]="sum.perfAbs >= 0" [class.text-color-error]="sum.perfAbs < 0" zeroBlink [val]="sum.perfAbs">
                {{ sum.perfPct | number: '1.2-2' }}&nbsp;%
              </div>
            </div>
            <div class="d-flex text-color-primary justify-content-end">
              <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow"></div>
              <div [class.text-color-success]="sum.perfAbs >= 0" [class.text-color-error]="sum.perfAbs < 0">
                {{ sum.perfAbs | currency }}
              </div>
            </div>
          </td>
          <td class="margin-xs-bottom-15 margin-sm-bottom-15 hidden-xs hidden-sm"></td>
          @if (actionsEnabled) {
            <td></td>
          }
        </tr>
      }
    </tbody>
  </table>
</ng-template>

<ng-template #dividendTable let-items="items" let-dividendYields="dividendYields" let-dividendSums="dividendSums">
  @if (depotFacade.dividendReinvestHint$ | async) {
    <shared-dividend-re-invest-hint type="dividends" />
  }

  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="text-size-large" [innerHTML]="'mydepot.depotoverview.positions.dividends.hint' | transloco"></div>
  </div>
  <table
    aria-describedby="positions"
    class="table-depot table-positions opacity-container table-dividend"
    [class.active]="isPotentialCustomer || items"
    @onlyEnter
  >
    <tbody>
      <tr>
        <th>
          <web-components-sorter-label
            [sorter]="sorter"
            attr="assetName"
            label="mydepot.depotoverview.positions.labels.assetName"
            direction="after"
            (click)="sortBy('assetName')"
          />
          <br />
          <web-components-sorter-label
            [sorter]="sorter"
            attr="isin"
            label="mydepot.depotoverview.positions.labels.isin"
            direction="after"
            (click)="sortBy('isin')"
          />
        </th>
        <th>
          {{ 'mydepot.depotoverview.positions.labels.quote' | transloco }}<br />
          <web-components-sorter-label
            [sorter]="sorter"
            attr="currentValue"
            label="mydepot.depotoverview.positions.labels.currentValue"
            direction="before"
            (click)="sortBy('currentValue')"
          />
        </th>
        @for (dividendPeriod of dividendPeriods; track $index) {
          <th [class.pr-0]="$index === 3">
            <div class="d-flex align-items-center justify-content-end">
              @if (dividendPeriod !== 'total') {
                {{ dividendPeriod }}
              } @else {
                <ng-container *ngTemplateOutlet="totalLabel" />
              }
              <br />
              @if (dividendPeriod | endsWith: 'e') {
                <ng-container *ngTemplateOutlet="expectedLabel" />
              } @else {
                {{ 'mydepot.depotoverview.positions.labels.dividend-earned' | transloco }}<br />
                {{ 'mydepot.depotoverview.positions.labels.dividend-yield' | transloco }}
              }
              @if ($index === 3) {
                <div class="vertical-separator hidden-xs hidden-sm hidden-md"></div>
              }
            </div>
          </th>
        }
      </tr>
      @for (item of items; track item.id) {
        @if (dividendYieldByIsin[item.isin]) {
          <tr
            zero-position-dividend
            [class.no-border]="(positionsSettings$ | async)?.notesVisible && item.note?.note"
            [item]="item"
            [dividendYield]="dividendYieldByIsin[item.isin]"
            [dividendPeriods]="dividendPeriods"
          ></tr>

          @if (positionsSettings$ | async; as settings) {
            @if (settings.notesVisible && item.note?.note) {
              <tr>
                <td [attr.colspan]="9">
                  <div class="d-flex align-items-center">
                    <div class="mr-2">{{ 'watchlist.note' | transloco }}</div>
                    <div class="width-100 note" [innerHTML]="item.note.note | noteSafeHtml"></div>
                  </div>
                </td>
              </tr>
            }
          }
        }
      }

      @if (!isLoading && (isPotentialCustomer || !filteredPositions?.length)) {
        <tr>
          <td colspan="7">
            {{ 'mydepot.depotoverview.positions.empty' | transloco }}
          </td>
        </tr>
      } @else if (isLoading) {
        <ng-container *ngTemplateOutlet="loadingShimmer" />
      }
      <tr class="top-align">
        <td>
          <div class="font-bold text-uppercase">
            {{ 'mydepot.depotoverview.positions.sum.label' | transloco }}
          </div>
        </td>
        <td class="hidden-xs hidden-sm">&nbsp;</td>
        @for (dividendPeriod of dividendPeriods; track $index) {
          <td [class.pr-0]="$index === 3">
            <div class="d-flex align-items-center justify-content-end text-color-primary">
              <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                @if (dividendPeriod === 'total') {
                  <ng-container *ngTemplateOutlet="totalLabel" />
                } @else {
                  {{ dividendPeriod }}
                }
                @if (dividendPeriod | endsWith: 'e') {
                  <ng-container *ngTemplateOutlet="expectedLabel" />
                } @else {
                  {{ 'mydepot.depotoverview.positions.labels.dividend-earned' | transloco }}
                }
                <br />
              </div>
              <div class="text-color-primary font-bold">
                @if (dividendSums[dividendPeriod]) {
                  @if (dividendPeriod | endsWith: 'e') {
                    ~
                  }
                  {{ dividendSums[dividendPeriod] | bigNumbers: '1.2-2' : true : 9999 }}
                  @if ($index === 3) {
                    €
                  }
                } @else {
                  <ng-container *ngTemplateOutlet="novalue" />
                }
              </div>
              @if ($index === 3) {
                <div class="vertical-separator hidden-xs hidden-sm hidden-md"></div>
              }
            </div>
          </td>
        }
      </tr>
    </tbody>
  </table>
</ng-template>

<ng-template #loadingShimmer>
  <tr>
    <td>
      <div class="loading-shimmer position"></div>
      <div class="loading-shimmer position"></div>
    </td>
    <td>
      <div class="loading-shimmer position"></div>
      <div class="loading-shimmer position"></div>
    </td>
    <td>
      <div class="loading-shimmer position"></div>
      <div class="loading-shimmer position"></div>
    </td>
    <td>
      <div class="loading-shimmer position"></div>
      <div class="loading-shimmer position"></div>
    </td>
    <td>
      <div class="loading-shimmer position"></div>
      <div class="loading-shimmer position"></div>
    </td>
    <td>
      <div class="loading-shimmer position"></div>
      <div class="loading-shimmer position"></div>
    </td>
    <td>
      <div class="loading-shimmer position"></div>
      <div class="loading-shimmer position"></div>
    </td>
  </tr>
</ng-template>

<ng-template #totalLabel>{{ 'mydepot.depotoverview.positions.labels.dividend-total' | transloco }}</ng-template>
<ng-template #expectedLabel> {{ 'mydepot.depotoverview.positions.labels.dividend-expected' | transloco }}</ng-template>
<ng-template #novalue>&mdash;</ng-template>
